import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect';
import { propMatch } from '@/helpers/custom-prop-types';
import { pagePath } from '@/utils/router/pagePath';
import { getProffitSearchValues, isProffitSearchFreePlan, } from '../../../../helpers/profile';
const ProffitSearchSlideAddHoc = () => (ChildComponent) => {
    const ProffitSearchSlideAddHocInner = (props) => {
        const profile = useSelector((state) => state.profile);
        const { plan } = useMemo(() => getProffitSearchValues(profile), [profile]);
        const isFree = isProffitSearchFreePlan(plan);
        // フリープランのユーザーはスライド追加不可なのでリダイレクトさせる
        if (isFree) {
            return _jsx(CustomRedirect, { to: pagePath.ProffitSearch.top() });
        }
        return _jsx(ChildComponent, Object.assign({}, props));
    };
    ProffitSearchSlideAddHocInner.propTypes = {
        match: propMatch(),
    };
    return ProffitSearchSlideAddHocInner;
};
export default ProffitSearchSlideAddHoc;
